import {
  isOnlyLetter,
  isOnlyNumber,
  isRequired,
  isMinChar
} from '../../../utils/validation';

export const initialValues = {
  accountName: '',
  accountNumber: '',
  bankName: '',
};

export const fieldsProps = {
  accountName: {
    name: 'accountName',
    placeholder: '',
    label: 'Nama Pemilik Rekening',
  },
  accountNumber: {
    name: 'accountNumber',
    placeholder: 'Masukkan Nomor Rekening',
    label: 'Nomor Rekening',
    minlength: 10,
  },
  bankName: {
    name: 'bankName',
    placeholder: 'Cari Nama Bank',
    label: 'Nama Bank',
  },
};

export const validate = (values = initialValues) => {
  const { accountName, accountNumber, bankName } = values;
  const rules = {
    accountName:
      isRequired(accountName, 'Nama Pemilik Rekening') ||
      isOnlyLetter(
        accountName,
        'Nama Pemilik Rekening hanya boleh diisi huruf'
      ),
    accountNumber:
      isRequired(accountNumber, 'Nomor Rekening harus diisi') ||
      isOnlyNumber(accountNumber, 'Nomor Rekening hanya boleh diisi angka') ||
      isMinChar(10, accountNumber, 'Panjang karakter Nomor Rekening minimal 10 karakter'),
    bankName: isRequired(bankName, 'Nama Bank harus dipilih'),
  };

  return rules;
};
